export const calculateStandardPrice = (activities) => activities.reduce((total, activity) => {
    let price = 0;
    if (activity.activeSession) {
        price = activity.activeSession.StandardPrice;
    }
    return total + price;
}, 0);
export const calculateTotalPrice = (activities) => activities.reduce((total, activity) => {
    let price = 0;
    if (activity.activeSession) {
        price = activity.activeSession.TotalPrice;
    }
    return total + price;
}, 0);
